export function statusLabel(s) {
  return {
    pending: 'Pendiente',
    in_progress: 'En curso',
    completed: 'Completada',
    canceled: 'Cancelada',
    draft: 'Borrador',
    submitted: 'Enviado',
  }[s] || s;
}

export function statusColor(s) {
  return {
    pending:     'var(--st-pending)',
    in_progress: 'var(--st-progress)',
    completed:   'var(--st-done)',
    canceled:    'var(--st-cancel)',
    draft:       'var(--st-pending)',
    submitted:   'var(--st-done)',
  }[s] || '#888';
}

export function statusColorSoft(s) {
  return {
    pending: 'rgba(178, 139, 71, 0.18)',
    in_progress: 'rgba(11, 105, 178, 0.16)',
    completed: 'rgba(42, 122, 66, 0.16)',
    canceled: 'rgba(146, 48, 48, 0.15)',
    draft: 'rgba(178, 139, 71, 0.18)',
    submitted: 'rgba(42, 122, 66, 0.16)',
  }[s] || 'rgba(136, 136, 136, 0.14)';
}
